// Institution approval of a student's event: the event stays hidden from other students until it is approved.
// Event create response: { data: { event_id, approval_status } }, event details: { approvalStatus }.
// Communities work the same way ("My University Only" communities): create response
// { data: { community_id, approval_status } }, my-communities list items: { approvalStatus, reviewNotes }.

export const EVENT_APPROVAL_MESSAGE =
  "Your event has been sent for approval. It will be visible once your institution approves it.";

export const COMMUNITY_APPROVAL_MESSAGE =
  "Your community has been sent for approval. It will be visible once your institution approves it.";

// "PENDING_APPROVAL", "pending approval" and "pendingApproval" all count
export const isPendingApproval = (status) =>
  String(status || "").replace(/[\s_]/g, "").toLowerCase() === "pendingapproval";

// True when an event create / publish response says the event is waiting for the institution
export const eventNeedsApproval = (res) =>
  isPendingApproval(res?.data?.approval_status ?? res?.data?.approvalStatus);

// Same response shape for community create / update
export const communityNeedsApproval = eventNeedsApproval;

// Owner-facing review state shown on "my" lists. tone picks the pill colour; notesPrefix labels the
// reviewer's notes for states that come with them.
const APPROVAL_STATES = {
  published: { label: "Published", tone: "published" },
  approved: { label: "Approved", tone: "published" },
  pendingapproval: { label: "Pending approval", tone: "pending" },
  rejected: { label: "Rejected", tone: "rejected", notesPrefix: "Rejected" },
  changesrequested: { label: "Changes requested", tone: "changes", notesPrefix: "Changes requested" },
};

export const getApprovalState = (status) =>
  APPROVAL_STATES[String(status || "").replace(/[\s_]/g, "").toLowerCase()] || null;

// Nobody can be invited to an event the institution hasn't approved (pending, changes requested or rejected).
// Returns the reason shown when the creator taps Invite, or null when inviting is allowed (approved, or no review).
const EVENT_INVITE_BLOCKED = {
  pending: "You can invite people once your institution approves this event.",
  changes: "Your institution has requested changes. You can invite people once it approves this event.",
  rejected: "Your institution rejected this event, so people can't be invited to it.",
};
export const getEventInviteBlock = (status) => EVENT_INVITE_BLOCKED[getApprovalState(status)?.tone] || null;

const COMMUNITY_INVITE_BLOCKED = {
  pending: "You can invite people once your institution approves this community.",
  changes: "Your institution has requested changes. You can invite people once it approves this community.",
  rejected: "Your institution rejected this community, so people can't be invited to it.",
};
export const getCommunityInviteBlock = (status) => COMMUNITY_INVITE_BLOCKED[getApprovalState(status)?.tone] || null;

// The create forms close right after saving, so the explanation is a popup owned by the app (ApprovalNotice,
// mounted in App.js) instead of something inside the form
export const APPROVAL_NOTICE_EVENT = "approvalNotice";
export const showApprovalNotice = (message = EVENT_APPROVAL_MESSAGE) => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(APPROVAL_NOTICE_EVENT, { detail: { message } }));
};
